import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Something went wrong.";
}

export const inr = (n) => "\u20B9" + Number(n || 0).toLocaleString("en-IN");
